<ng-container>
    <app-fiel-title label="{{label}}" required="{{required}}"></app-fiel-title>
    <div class="card flex p-mt-3">
        <div class="p-checkbox">
            <p-checkbox 
                [binary]="true" 
                label="{{checkBoxes[0]}}" 
                [(ngModel)]="checkedTrue" 
                (onChange)="onChangeValueResp('SI',$event)"
                [disabled]="disabled">
            </p-checkbox>  
            <div class="p-ml-3">
                <p-checkbox 
                    [binary]="true" 
                    label="{{checkBoxes[1]}}" 
                    [(ngModel)]="checkedFalse" 
                    (onChange)="onChangeValueResp('NO',$event)"
                    [disabled]="disabled">
                </p-checkbox>
            </div>
        </div>
        <app-invalid-from-message *ngIf="(!checkedTrue && !checkedFalse) && checkedError"></app-invalid-from-message>
    </div>
</ng-container>
